import { render, staticRenderFns } from "./OrderOptionCards.vue?vue&type=template&id=0d2c8805&scoped=true&"
import script from "./OrderOptionCards.vue?vue&type=script&lang=ts&"
export * from "./OrderOptionCards.vue?vue&type=script&lang=ts&"
import style0 from "./OrderOptionCards.vue?vue&type=style&index=0&id=0d2c8805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c8805",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
